const routes = [
  {
    path: 'texting/settings',
    component: () => import(/* webpackChunkName: "TextingSettings" */ './views/TextingSettings.vue'),
    name: 'textingSettings',
    props: (route) => ({ ...route.query, ...route.params }),
    meta: { pageNameEn: 'Texting Settings' },
  },
];

export default routes;
